import { render, staticRenderFns } from "./StaffSelectionDropdown.vue?vue&type=template&id=096f73bb"
import script from "./StaffSelectionDropdown.vue?vue&type=script&lang=js"
export * from "./StaffSelectionDropdown.vue?vue&type=script&lang=js"
import style0 from "./StaffSelectionDropdown.vue?vue&type=style&index=0&id=096f73bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports